module.exports = __webpack_public_path__ + "img/vertical_7_3_6000.cbd93976.png";